import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CommonService, CrudComponent } from 'wire-frame';

import { TagModule } from 'primeng/tag';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DropdownModule } from 'primeng/dropdown';
import { ToolbarModule } from 'primeng/toolbar';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { EditorModule } from 'primeng/editor';
import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AccordionModule } from 'primeng/accordion';
import { ScrollPanelModule } from 'primeng/scrollpanel';

import { PharmacyService } from '../../../service/admin/pharmacy.service';
import { ToasterService } from '../../../service/common/toaster.service';

@Component({
  selector: 'app-pharmacy',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    TagModule,
    ToggleButtonModule,
    DropdownModule,
    ToolbarModule,
    ToastModule,
    ConfirmDialogModule,
    CrudComponent,
    EditorModule,
    ButtonModule,
    TabViewModule,
    AccordionModule,
    ScrollPanelModule,
    InputTextModule,
    FileUploadModule,
    InputTextareaModule],
  providers: [ConfirmationService, CommonService, PharmacyService],
  templateUrl: './pharmacy.component.html',
  styleUrls: ['./pharmacy.component.scss'],
})
export class PharmacyComponent {
  activeIndex: number = 0;
  pationtIndex: number = 0;

  public PharmacyList: any[] = [];
  public editRecord: any = null;

  public Pharmacy: any = {
    id: '',
    name: '',
    medicines: '',
    visit_date: new Date().toISOString().slice(0, 10), // date in YYYY-MM-DD
    visit_time: '', // new field for pickup time
  };

  public closeFormEvent: boolean = false;
  public openDeletePopup: any = null;
  public activeMenu: string = 'basic';

  constructor(
    public common: CommonService,
    private toaster: ToasterService, private confirmationService: ConfirmationService,
    private PharmacyService: PharmacyService
  ) {
    this.common.breadCrum = {
      title: 'Pharmacy',
      icon: 'users',
      list: ['Pharmacy'],
    };

    this.common.setCrudTableHeaders([
      { title: 'Company Name', val: 'companyName', id: 'id', showColumn: true, filterColmn: true, order: 'asc', searchColumn: true, type: 'string', globalSearch: true },
      { title: 'Contact Person', val: 'contactPerson', id: 'id', showColumn: true, filterColmn: true, order: 'asc', searchColumn: true, type: 'string', globalSearch: true },
      { title: 'Phone Number', val: 'phoneNumber', id: 'id', showColumn: true, filterColmn: false, order: 'asc', searchColumn: false, type: 'string', globalSearch: false },
      { title: 'Email Address', val: 'emailAddress', id: 'id', showColumn: true, filterColmn: false, order: 'asc', searchColumn: false, type: 'string', globalSearch: false },
      { title: 'Address', val: 'address', id: 'id', showColumn: true, filterColmn: false, order: 'asc', searchColumn: false, type: 'string', globalSearch: false }]);

    this.common.setCrudActions([
      { title: '', icon: 'pi-pencil', classArr: 'me-2', tooltip: 'Update Pharmacy' },
      { title: '', icon: 'pi-trash', tooltip: 'Delete Pharmacy' }]);
  }

  ngOnInit() {
    this.getPharmacy();
  }

  getPharmacy() {
    this.PharmacyService.getPharmacyList().subscribe((res: any) => {
      this.PharmacyList = res.data;
    });
  }

  closeForm() {
    this.clearForm();
    this.closeFormEvent = true;
    setTimeout(() => {
      this.closeFormEvent = false;
    }, 1);
  }

  clearForm() {
    this.Pharmacy = {
      id: '',
      name: '',
      medicines: '',
      visit_date: new Date().toISOString().slice(0, 10),
      visit_time: '',
    };
  }

  processPharmacy() {
    if (this.Pharmacy?.id) {
      this.updatePharmacy();
    } else {
      this.addPharmacy();
    }
  }

  addPharmacy() {
    this.PharmacyService.addPharmacy(this.Pharmacy).subscribe((res: any) => {
      if (res.status) {
        this.toaster.success(res.message);
        this.getPharmacy();
        this.closeForm();
      } else {
        this.toaster.error(res.message);
      }
    });
  }

  updatePharmacy() {
    this.PharmacyService.updatePharmacy(this.Pharmacy).subscribe((res: any) => {
      if (res.status) {
        this.toaster.success(res.message);
        this.getPharmacy();
        this.closeForm();
      } else {
        this.toaster.error(res.message);
      }
    });
  }

  deletePharmacy(item: any) {
    this.PharmacyService.deletePharmacy(item).subscribe(() => {
      this.toaster.success('Pharmacy deleted successfully');
      this.getPharmacy();
      this.closeForm();
    });
  }

  deleteRecord(event: any) {
    if (event) {
      this.deletePharmacy(event);
    }
  }

  handleEvent(event: any) {
    if (event.action.tooltip === 'Update Pharmacy') {
      this.editRecord = event.data;
      this.Pharmacy = { ...event.data };
      setTimeout(() => {
        this.editRecord = null;
      }, 1);
    } else if (event.action.tooltip === 'Delete Pharmacy') {
      this.editRecord = event.data;
      this.delRecPopupOpen({ title: this.editRecord?.['name'], obj: this.editRecord });
    }
  }

  delRecPopupOpen(item: any) {
    this.openDeletePopup = item;
    setTimeout(() => {
      this.openDeletePopup = null;
    }, 1);
  }

  autoFillForm(queueName: string) {
    const sampleData: any = {
      'Amit Virkar': { name: 'Amit Virkar', medicines: 'Paracetamol 500mg, Cough Syrup', visit_date: '2025-08-29', visit_time: '12:30' },
      'Rahul Sharma': { name: 'Rahul Sharma', medicines: 'Vitamin D3, Pain Killer', visit_date: '2025-09-01', visit_time: '13:00' },
      'Sneha Patil': { name: 'Sneha Patil', medicines: 'Antibiotics, Calcium Tablets', visit_date: '2025-09-02', visit_time: '14:00' },
    };

    if (sampleData[queueName]) {
      this.Pharmacy = { ...sampleData[queueName] };
    } else {
      this.Pharmacy = {
        name: queueName,
        medicines: 'Default Medicine',
        visit_date: new Date().toISOString().slice(0, 10),
        visit_time: '',
      };
    }
  }
}
